import { useCallback, useLayoutEffect, useRef } from 'react'

/**
 * Returns a function with a permanent identity that always calls the latest `fn`.
 * Lets memoized children receive handlers without re-rendering when the parent re-renders.
 */
export function useStableCallback<T extends (...args: any[]) => any>(fn: T | undefined): T {
    const ref = useRef(fn)
    useLayoutEffect(() => {
        ref.current = fn
    })
    return useCallback(((...args: any[]) => ref.current?.(...args)) as T, [])
}

export default useStableCallback
